import { Box, Button, Popover, Typography } from '@mui/material'
import React, { ChangeEvent, useState } from 'react'
import { useWpAuthContext } from 'services/auth/WpAuthProvider'
import { setDataToLocalStorage } from 'utils/localStorage'
import {
  StyledSelect,
  StyledSelectButton,
  StyledSelectDropdownButton
} from './styled'

export const LicenseSelect: React.FC = () => {
  const { licenseTypes, setCurrentLicense, currentLicense } = useWpAuthContext()

  const [anchorEl, setAnchorEl] = React.useState<HTMLButtonElement | null>(null)

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget)
  }

  const handleClose = () => {
    setAnchorEl(null)
  }

  const open = Boolean(anchorEl)
  const id = open ? 'simple-popover' : undefined

  const setLicense = (license: string) => {
    setCurrentLicense(license)
    setDataToLocalStorage({ key: 'license', value: license })
    handleClose()
    window.location.reload()
  }
  return (
    <Box>
      {licenseTypes && (
        <StyledSelectButton
          aria-describedby={id}
          variant="contained"
          onClick={handleClick}
          disableRipple
        >
          {licenseTypes[currentLicense]}
        </StyledSelectButton>
      )}
      <Popover
        id={id}
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left'
        }}
        transitionDuration={0}
      >
        <StyledSelect>
          {licenseTypes &&
            Object.entries(licenseTypes).map(([key, value]) => {
              return (
                <StyledSelectDropdownButton
                  key={key}
                  className={currentLicense === key ? 'active' : ''}
                  onClick={() => setLicense(key)}
                >
                  {value as React.ReactNode}
                </StyledSelectDropdownButton>
              )
            })}
        </StyledSelect>
      </Popover>
    </Box>
  )
}
